import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchGoals, createGoal } from '../services/goal.service';
import { GoalDto } from '../types/dtos/common';

export const useGoals = (organizationId: string) => {
  return useQuery<GoalDto[], Error>({
    queryKey: ['goals', organizationId],
    queryFn: () => fetchGoals(organizationId),
    enabled: !!organizationId,
  });
};

export const useCreateGoal = (organizationId: string) => {
  const queryClient = useQueryClient();
  return useMutation<GoalDto, Error, Omit<GoalDto, 'id'>>({
    mutationFn: (goal: Omit<GoalDto, 'id'>) => createGoal(organizationId, goal),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['goals', organizationId] });
    },
  });
}; 